import { useContext, useState } from "react";
import { TripCostInput } from "../body/trip-summary/trip-cost-input";
import {
  CtaButton,
  Disclaimer,
  ExpandButton,
  ExpandIcon,
  InputContainer,
  Container,
  RowContainer,
  TextAndCost,
  AllTravelers,
} from "./styles";
import { OfferContext } from "..";
import { useTrackCtaPressed } from "../tracking";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectFormattedTotalPrice } from "store/quote/selectors";
import { useTranslation } from "react-i18next";
import classNames from "classnames";

export function OfferCtaBar() {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const { invalidTripCost } = useContext(OfferContext);
  const formattedTotalPrice = useSelector(selectFormattedTotalPrice);

  const { t } = useTranslation("screens", {
    keyPrefix: "offer",
  });

  const trackCtaPressed = useTrackCtaPressed({
    interaction_region: "cta bar",
    interaction_text: t("ctaBar.payment.label"),
  });

  const navigate = useNavigate();

  const toggleExpand = () => {
    setIsExpanded((prev) => !prev);
  };

  return (
    <Container className={classNames({ expanded: isExpanded })}>
      <RowContainer>
        <TextAndCost>
          <span>
            {t("tripCost.based_on_trip_cost")}
            <ExpandButton
              onClick={() => {
                toggleExpand();
              }}
            >
              <ExpandIcon className={classNames({ expanded: isExpanded })} />
            </ExpandButton>
          </span>
          <AllTravelers>{t("tripCost.for_all_travelers")}</AllTravelers>
        </TextAndCost>
        <InputContainer>
          <TripCostInput onError={setErrorMessage} />
        </InputContainer>
      </RowContainer>
      {errorMessage && (
        <Disclaimer className={classNames("error", { expanded: isExpanded })}>
          {errorMessage}
        </Disclaimer>
      )}
      {!errorMessage && isExpanded && (
        <Disclaimer className={classNames({ expanded: isExpanded })}>
          {t("ctaBar.disclaimer")}
        </Disclaimer>
      )}

      <CtaButton
        disabled={invalidTripCost?.value}
        className={classNames({ expanded: isExpanded })}
        onClick={() => {
          navigate("/checkout");
          trackCtaPressed();
        }}
      >
        {t("ctaBar.payment.label", { price: formattedTotalPrice })}
      </CtaButton>
    </Container>
  );
}
